import toast from "react-hot-toast";
import {useTranslation} from "react-i18next";
import fbLogo from "./../../images/login/fb.svg";
import {loadFacebookSdk} from "./facebookSdk.js";

export default function FacebookLoginButton({configurationId, config, onClick, children, onSuccess, className}) {

    let {t} = useTranslation();

    let handleFacebook = (response) => {
        // noinspection JSUnresolvedReference
        if (response?.authResponse === null) {
            toast.error(t('auth.error'));
            return;
        }

        // noinspection JSUnresolvedReference
        let code = response.authResponse.accessToken ?? response.authResponse.code;

        if (response?.status === 'connected' && code !== null) {
            // noinspection JSUnresolvedReference
            onSuccess(response.authResponse.accessToken ?? response.authResponse.code);
            return;
        }

        toast.error(t('auth.error'));
    };

    let handleClick = async () => {

        if (!onClick) {
            try {
                const facebook = await loadFacebookSdk();
                facebook.login(handleFacebook, {
                    config_id: configurationId,
                    ...config,
                });
            } catch {
                toast.error(t('auth.error'));
            }
            return;
        }

        onClick();
    };

    // noinspection JSValidateTypes
    return (
        <button
            type={'button'}
            className={`social-login-btn facebook ${className ?? ''}`}
            onClick={handleClick}
        >
            <img src={fbLogo} alt="Facebook" className="h-[20px] w-[20px]"/>
            {children}
        </button>
    );
}
